import { IngInputBase } from './ing-input-base';

export class IngTinyMce extends IngInputBase<string> {
  public options: any;
  public height: number;
  constructor(
    options: {
      value?: string,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      options?: any,
      height?: number,
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    super(options);

    this.options = options.options || {};
    this.height  = options.height  || 280;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-tiny-mce.ts